import type { QuestionSingle } from '@repo/lib/quiz/questions/class/QuestionSingle';
import type { AnswerQuestionSingle } from '@repo/types/questions/QuestionSingle';

import type { QuestionSingleProps } from '@/components/features/quiz/question/question-resolver/question-single';

import { useQuestionState } from '@/hooks/questions';

export function useQuestionSingle(questionSingleProps: QuestionSingleProps) {
  const { question, sectionIndex, questionIndex } = questionSingleProps;
  const { getAnswer, getContent, setAnswer, getMarked, exportedAnswer } = useQuestionState<QuestionSingle>(question, sectionIndex, questionIndex);
  const { answers } = getContent();
  const marked = getMarked();
  const userAnswer = getAnswer();
  const exportedUserAnswer = exportedAnswer();

  const getMarkedState = (answer: AnswerQuestionSingle) => {
    if (userAnswer?.id === answer.id) {
      return marked?.correct;
    }
    return undefined;
  };

  return {
    marked,
    answers,
    userAnswer,
    exportedUserAnswer,
    setAnswer,
    getMarkedState,
  };
}
